import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eThietLapChuanDauRaActionsObj = {
    CHANGE_SELECTED_LOAI_CHUNG_CHI: {} as number,

    CHANGE_SELECTED_CTDT_IDS: {} as number[],

    CHANGE_FILTER_CTDT: {} as {
        id_he: number;
        khoa_hoc: number;
    },

    SHOW_GAN_MON_CHUNG_CHI_MODAL: {} as number[],
    CLOSE_GAN_MON_CHUNG_CHI_MODAL: undefined,
}
export const eThietLapChuanDauRaActionIds = generateActionTypeIds(eThietLapChuanDauRaActionsObj, "THIET_LAP_CHUAN_DAU_RA");
export type IThietLapChuanDauRaActionTypes = IGenericActionType<typeof eThietLapChuanDauRaActionsObj, "THIET_LAP_CHUAN_DAU_RA">;